import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Dropdown, Label } from 'semantic-ui-react';

class ThemeSelector extends React.PureComponent {
  static propTypes = {
    list: PropTypes.array,
    onSelect: PropTypes.func,
    defaultValue: PropTypes.string,
    label: PropTypes.string,
  };

  static defaultProps = {
    list: [],
    onSelect: () => null,
    defaultValue: null,
    label: 'Thème',
  };

  render() {
    const options = _.map(this.props.list, e => ({
      key: e.key,
      value: e.key,
      text: `${e.nom} ${!e.groupe ? '' : ' (' + e.groupe + ')'}`,
    }));
    if (options.length > 1) {
      return (
        <Label>{this.props.label}<br />
          <Dropdown
            search
            selection
            selectOnBlur={false}
            selectOnNavigation={false}
            // direction="left"
            defaultValue={this.props.defaultValue}
            options={options}
            onChange={(e, { value }) => {
              this.props.onSelect(value);
            }}
          />
        </Label>
      );
    } else if (options.length === 1) {
      return (<Label basic color="grey" size="large">{this.props.label} : {options[0].text}</Label>);
    }
    return null;
  }
}


export default ThemeSelector;



// WEBPACK FOOTER //
// ./src/components/Menu/ThemeSelector.js